function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * Regions are visual overlays on the waveform that can be used to mark segments of audio.
 * Regions can be clicked on, dragged and resized.
 * You can set the color and content of each region, as well as their HTML content.
 */
import BasePlugin from '../base-plugin.js';
import { makeDraggable } from '../draggable.js';
import EventEmitter from '../event-emitter.js';

var SingleRegion = /*#__PURE__*/function (_EventEmitter) {
  _inherits(SingleRegion, _EventEmitter);

  var _super = _createSuper(SingleRegion);

  function SingleRegion(params, totalDuration) {
    var _this;

    _classCallCheck(this, SingleRegion);

    var _a, _b, _c, _d, _e, _f;

    _this = _super.call(this);
    _this.totalDuration = totalDuration;
    _this.minLength = 0;
    _this.maxLength = Infinity;
    _this.id = params.id || "region-".concat(Math.random().toString(32).slice(2));
    _this.start = params.start;
    _this.end = (_a = params.end) !== null && _a !== void 0 ? _a : params.start;
    _this.drag = (_b = params.drag) !== null && _b !== void 0 ? _b : true;
    _this.resize = (_c = params.resize) !== null && _c !== void 0 ? _c : true;
    _this.color = (_d = params.color) !== null && _d !== void 0 ? _d : 'rgba(0, 0, 0, 0.1)';
    _this.minLength = (_e = params.minLength) !== null && _e !== void 0 ? _e : _this.minLength;
    _this.maxLength = (_f = params.maxLength) !== null && _f !== void 0 ? _f : _this.maxLength;
    _this.element = _this.initElement(params.content);

    _this.renderPosition();

    _this.initMouseEvents();

    return _this;
  }

  _createClass(SingleRegion, [{
    key: "initElement",
    value: function initElement(content) {
      var element = document.createElement('div');
      var isMarker = this.start === this.end;
      element.setAttribute('part', "".concat(isMarker ? 'marker' : 'region', " ").concat(this.id));
      element.setAttribute('style', "\n      position: absolute;\n      height: 100%;\n      background-color: ".concat(isMarker ? 'none' : this.color, ";\n      border-left: ").concat(isMarker ? '2px solid ' + this.color : 'none', ";\n      border-radius: 2px;\n      box-sizing: border-box;\n      transition: background-color 0.2s ease;\n      cursor: ").concat(this.drag ? 'grab' : 'default', ";\n      pointer-events: all;\n    ")); // Init content

      if (content) {
        if (typeof content === 'string') {
          this.content = document.createElement('div');
          this.content.style.padding = "0.2em ".concat(isMarker ? 0.2 : 0.4, "em");
          this.content.textContent = content;
        } else {
          this.content = content;
        }

        this.content.setAttribute('part', 'region-content');
        element.appendChild(this.content);
      } // Add resize handles


      if (!isMarker) {
        var leftHandle = document.createElement('div');
        leftHandle.setAttribute('data-resize', 'left');
        leftHandle.setAttribute('style', "\n        position: absolute;\n        z-index: 2;\n        width: 6px;\n        height: 100%;\n        top: 0;\n        left: 0;\n        border-left: 2px solid rgba(0, 0, 0, 0.5);\n        border-radius: 2px 0 0 2px;\n        cursor: ".concat(this.resize ? 'ew-resize' : 'default', ";\n        word-break: keep-all;\n      "));
        leftHandle.setAttribute('part', 'region-handle region-handle-left');
        var rightHandle = leftHandle.cloneNode();
        rightHandle.setAttribute('data-resize', 'right');
        rightHandle.style.left = '';
        rightHandle.style.right = '0';
        rightHandle.style.borderRight = rightHandle.style.borderLeft;
        rightHandle.style.borderLeft = '';
        rightHandle.style.borderRadius = '0 2px 2px 0';
        rightHandle.setAttribute('part', 'region-handle region-handle-right');
        element.appendChild(leftHandle);
        element.appendChild(rightHandle);
      }

      return element;
    }
  }, {
    key: "renderPosition",
    value: function renderPosition() {
      var start = this.start / this.totalDuration;
      var end = (this.totalDuration - this.end) / this.totalDuration;
      this.element.style.left = "".concat(start * 100, "%");
      this.element.style.right = "".concat(end * 100, "%");
    }
  }, {
    key: "initMouseEvents",
    value: function initMouseEvents() {
      var _this2 = this;

      var element = this.element;
      if (!element) return;
      element.addEventListener('click', function (e) {
        return _this2.emit('click', e);
      });
      element.addEventListener('mouseenter', function (e) {
        return _this2.emit('over', e);
      });
      element.addEventListener('mouseleave', function (e) {
        return _this2.emit('leave', e);
      });
      element.addEventListener('dblclick', function (e) {
        return _this2.emit('dblclick', e);
      }); // Drag

      makeDraggable(element, function (dx) {
        return _this2.onMove(dx);
      }, function () {
        return _this2.onStartMoving();
      }, function () {
        return _this2.onEndMoving();
      }); // Resize

      var resizeThreshold = 1;
      makeDraggable(element.querySelector('[data-resize="left"]'), function (dx) {
        return _this2.onResize(dx, 'start');
      }, function () {
        return null;
      }, function () {
        return _this2.onEndResizing();
      }, resizeThreshold);
      makeDraggable(element.querySelector('[data-resize="right"]'), function (dx) {
        return _this2.onResize(dx, 'end');
      }, function () {
        return null;
      }, function () {
        return _this2.onEndResizing();
      }, resizeThreshold);
    }
  }, {
    key: "onStartMoving",
    value: function onStartMoving() {
      if (!this.drag) return;
      this.element.style.cursor = 'grabbing';
    }
  }, {
    key: "onEndMoving",
    value: function onEndMoving() {
      if (!this.drag) return;
      this.element.style.cursor = 'grab';
      this.emit('update-end');
    }
  }, {
    key: "_onUpdate",
    value: function _onUpdate(dx, side) {
      if (!this.element.parentElement) return;
      var deltaSeconds = dx / this.element.parentElement.clientWidth * this.totalDuration;
      var newStart = !side || side === 'start' ? this.start + deltaSeconds : this.start;
      var newEnd = !side || side === 'end' ? this.end + deltaSeconds : this.end;
      var length = newEnd - newStart;

      if (newStart >= 0 && newEnd <= this.totalDuration && newStart <= newEnd && length >= this.minLength && length <= this.maxLength) {
        this.start = newStart;
        this.end = newEnd;
        this.renderPosition();
        this.emit('update');
      }
    }
  }, {
    key: "onMove",
    value: function onMove(dx) {
      if (!this.drag) return;

      this._onUpdate(dx);
    }
  }, {
    key: "onResize",
    value: function onResize(dx, side) {
      if (!this.resize) return;

      this._onUpdate(dx, side);
    }
  }, {
    key: "onEndResizing",
    value: function onEndResizing() {
      if (!this.resize) return;
      this.emit('update-end');
    }
  }, {
    key: "_setTotalDuration",
    value: function _setTotalDuration(totalDuration) {
      this.totalDuration = totalDuration;
      this.renderPosition();
    }
    /** Play the region from start to end */

  }, {
    key: "play",
    value: function play() {
      this.emit('play');
    }
    /** Update the region's options */

  }, {
    key: "setOptions",
    value: function setOptions(options) {
      var _this3 = this;

      var _a, _b;

      if (options.color) {
        this.color = options.color;
        this.element.style.backgroundColor = this.color;
      }

      if (options.drag !== undefined) {
        this.drag = options.drag;
        this.element.style.cursor = this.drag ? 'grab' : 'default';
      }

      if (options.resize !== undefined) {
        this.resize = options.resize;
        this.element.querySelectorAll('[data-resize]').forEach(function (handle) {
          ;
          handle.style.cursor = _this3.resize ? 'ew-resize' : 'default';
        });
      }

      if (options.start !== undefined || options.end !== undefined) {
        this.start = (_a = options.start) !== null && _a !== void 0 ? _a : this.start;
        this.end = (_b = options.end) !== null && _b !== void 0 ? _b : this.end;
        this.renderPosition();
      }
    }
    /** Remove the region */

  }, {
    key: "remove",
    value: function remove() {
      this.emit('remove');
      this.element.remove(); // This violates the type but we want to clean up the DOM reference
      // w/o having to have a nullable type of the element

      this.element = null;
    }
  }]);

  return SingleRegion;
}(EventEmitter);

var RegionsPlugin = /*#__PURE__*/function (_BasePlugin) {
  _inherits(RegionsPlugin, _BasePlugin);

  var _super2 = _createSuper(RegionsPlugin);

  /** Create an instance of RegionsPlugin */
  function RegionsPlugin(options) {
    var _this4;

    _classCallCheck(this, RegionsPlugin);

    _this4 = _super2.call(this, options);
    _this4.regions = [];
    _this4.regionsContainer = _this4.initRegionsContainer();
    return _this4;
  }
  /** Create an instance of RegionsPlugin */


  _createClass(RegionsPlugin, [{
    key: "onInit",
    value:
    /** Called by wavesurfer, don't call manually */
    function onInit() {
      var _this5 = this;

      if (!this.wavesurfer) {
        throw Error('WaveSurfer is not initialized');
      }

      this.wavesurfer.getWrapper().appendChild(this.regionsContainer); // Detect when a region is being played

      var activeRegion = null;
      this.subscriptions.push(this.wavesurfer.on('timeupdate', function (currentTime) {
        var playedRegion = _this5.regions.find(function (region) {
          return region.start <= currentTime && region.end >= currentTime;
        });

        if (activeRegion && activeRegion !== playedRegion) {
          _this5.emit('region-out', activeRegion);

          activeRegion = null;
        }

        if (playedRegion && playedRegion !== activeRegion) {
          activeRegion = playedRegion;

          _this5.emit('region-in', playedRegion);
        }
      }));
    }
  }, {
    key: "initRegionsContainer",
    value: function initRegionsContainer() {
      var div = document.createElement('div');
      div.setAttribute('style', "\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      z-index: 3;\n      pointer-events: none;\n    ");
      return div;
    }
    /** Get all created regions */

  }, {
    key: "getRegions",
    value: function getRegions() {
      return this.regions;
    }
  }, {
    key: "avoidOverlapping",
    value: function avoidOverlapping(region) {
      if (!region.content) return; // Check that the label doesn't overlap with other labels
      // If it does, push it down until it doesn't

      var div = region.content;
      var labelLeft = div.getBoundingClientRect().left;
      var labelWidth = region.element.scrollWidth;
      var overlap = this.regions.filter(function (reg) {
        if (reg === region || !reg.content) return false;
        var left = reg.content.getBoundingClientRect().left;
        var width = reg.element.scrollWidth;
        return labelLeft < left + width && left < labelLeft + labelWidth;
      }).map(function (reg) {
        var _a;

        return ((_a = reg.content) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height) || 0;
      }).reduce(function (sum, val) {
        return sum + val;
      }, 0);
      div.style.marginTop = "".concat(overlap, "px");
    }
  }, {
    key: "saveRegion",
    value: function saveRegion(region) {
      var _this6 = this,
          _this$subscriptions;

      this.regionsContainer.appendChild(region.element);
      this.avoidOverlapping(region);
      this.regions.push(region);
      this.emit('region-created', region);
      var regionSubscriptions = [region.on('update-end', function () {
        _this6.avoidOverlapping(region);

        _this6.emit('region-updated', region);
      }), region.on('play', function () {
        var _a, _b;

        (_a = _this6.wavesurfer) === null || _a === void 0 ? void 0 : _a.play();
        (_b = _this6.wavesurfer) === null || _b === void 0 ? void 0 : _b.setTime(region.start);
      }), region.on('click', function (e) {
        _this6.emit('region-clicked', region, e);
      }), region.on('dblclick', function (e) {
        _this6.emit('region-double-clicked', region, e);
      }), // Remove the region from the list when it's removed
      region.once('remove', function () {
        regionSubscriptions.forEach(function (unsubscribe) {
          return unsubscribe();
        });
        _this6.regions = _this6.regions.filter(function (reg) {
          return reg !== region;
        });
      })];

      (_this$subscriptions = this.subscriptions).push.apply(_this$subscriptions, regionSubscriptions);
    }
    /** Create a region with given parameters */

  }, {
    key: "addRegion",
    value: function addRegion(options) {
      var _this7 = this;

      if (!this.wavesurfer) {
        throw Error('WaveSurfer is not initialized');
      }

      var duration = this.wavesurfer.getDuration();
      var region = new SingleRegion(options, duration);

      if (!duration) {
        this.subscriptions.push(this.wavesurfer.once('ready', function (duration) {
          region._setTotalDuration(duration);

          _this7.saveRegion(region);
        }));
      } else {
        this.saveRegion(region);
      }

      return region;
    }
    /**
     * Enable creation of regions by dragging on an empty space on the waveform.
     * Returns a function to disable the drag selection.
     */

  }, {
    key: "enableDragSelection",
    value: function enableDragSelection(options) {
      var _this8 = this;

      var _a, _b;

      var wrapper = (_b = (_a = this.wavesurfer) === null || _a === void 0 ? void 0 : _a.getWrapper()) === null || _b === void 0 ? void 0 : _b.querySelector('div');
      if (!wrapper) return function () {
        return undefined;
      };
      var initialSize = 5;
      var region = null;
      var startX = 0;
      return makeDraggable(wrapper, // On drag move
      function (dx, _dy, x) {
        if (region) {
          // Update the end position of the region
          // If we're dragging to the left, we need to update the start instead
          region._onUpdate(dx, x > startX ? 'end' : 'start');
        }
      }, // On drag start
      function (x) {
        startX = x;
        if (!_this8.wavesurfer) return;

        var duration = _this8.wavesurfer.getDuration();

        var width = _this8.wavesurfer.getWrapper().clientWidth; // Calculate the start time of the region


        var start = x / width * duration; // Give the region a small initial size

        var end = (x + initialSize) / width * duration; // Create a region but don't save it until the drag ends

        region = new SingleRegion(Object.assign(Object.assign({}, options), {
          start: start,
          end: end
        }), duration); // Just add it to the DOM for now

        _this8.regionsContainer.appendChild(region.element);
      }, // On drag end
      function () {
        if (region) {
          _this8.saveRegion(region);

          region = null;
        }
      });
    }
    /** Remove all regions */

  }, {
    key: "clearRegions",
    value: function clearRegions() {
      this.regions.forEach(function (region) {
        return region.remove();
      });
    }
    /** Destroy the plugin and clean up */

  }, {
    key: "destroy",
    value: function destroy() {
      this.clearRegions();

      _get(_getPrototypeOf(RegionsPlugin.prototype), "destroy", this).call(this);
    }
  }], [{
    key: "create",
    value: function create(options) {
      return new RegionsPlugin(options);
    }
  }]);

  return RegionsPlugin;
}(BasePlugin);

export default RegionsPlugin;